// extracted by mini-css-extract-plugin
module.exports = {"modal":"SentryProvider_modal__Q0KZx","buttons":"SentryProvider_buttons__8n1Vj"};